import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Toronto" });
export const lineStatus = (l, d = today()) => (!l.start ? "always" : d < l.start ? "upcoming" : d > l.end ? "ended" : "live");

// Lines that should show today: scheduled "show alone" lines replace everything while live.
export const activeLines = (lines, d = today()) => {
  const on = (lines || []).filter((l) => ["always", "live"].includes(lineStatus(l, d)));
  const solo = on.filter((l) => l.start && l.mode === "only");
  return solo.length ? solo : on;
};

export const fillCount = (text, total) => (text || "").replace(/\{count\}/g, String(total ?? 0));

// Line under the hero headline; fades through the admin's taglines every `speed` seconds.
export function RotatingTagline({ lines, lang, total, speed = 4, className = "", testid = "hero-stats" }) {
  const list = activeLines(lines).map((l) => fillCount(lang === "fr" ? (l.text_fr || l.text) : l.text, total)).filter(Boolean);
  const [i, setI] = useState(0);
  const n = list.length;
  useEffect(() => { setI(0); }, [n]);
  useEffect(() => {
    if (n < 2) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % n), Math.max(2, speed) * 1000);
    return () => clearInterval(t);
  }, [n, speed]);
  if (!n) return null;
  return (
    <div className={`relative h-6 overflow-hidden ${className}`} data-testid={testid} data-index={i % n} aria-live="polite">
      <AnimatePresence mode="wait" initial={false}>
        <motion.p key={`${i % n}-${list[i % n]}`} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.35 }} className="absolute inset-x-0 truncate">{list[i % n]}</motion.p>
      </AnimatePresence>
    </div>
  );
}
